/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

import PackageModel from '@/api/package/package.model';
import { ServicePointDeliveryModel } from '@/api/service-point/delivery/delivery.model';
import StatusModel from '@/api/status/status.model';

/**
 * Export `ServicePointOrderModel`.
 */
@endpoint('servicePointOrder')
export class ServicePointOrderModel extends BaseModel {
  /**
   * Properties.
   */
  id: number;

  deliveredTo: string;

  delivery: ServicePointDeliveryModel;

  packages: PackageModel[];

  status: StatusModel;

  statusDate: string;

  trackingNumberKey?: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<ServicePointOrderModel>) {
    super(data);
  }
}
